var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-filter-checkbox",class:{ pretty: _vm.pretty }},[_c('label',{staticClass:"xs-title"},[_vm._v(_vm._s(_vm.$attrs.name))]),_c('div',{staticClass:"checkboxes",class:{ pretty: _vm.pretty }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }